module.exports = __webpack_public_path__ + "static/img/page6-bg.fd07a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page6-bg.png
// module id = SpqQ
// module chunks = 215